import { BaseApi } from '~/api/base'

/**
 * Core SSR-safe API composable for Nuxt 3.
 *
 * Returns a configured `BaseApi` instance whose `ofetch` client:
 * - Reads the API base URL from runtime config
 * - Attaches the auth token from localStorage (client-side)
 * - Auto-serializes JSON / FormData bodies
 * - Normalizes error responses
 */
export function useApi() {
  const {
    public: { apiBase },
  } = useRuntimeConfig()

  const api = new BaseApi(apiBase as string)

  return { api }
}
